import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { GqlParser, MutationResult } from '@unipin/angular-gql';
import { AppLoginSubject, UpdateProfileRq, UserLogin } from 'graphql/generated';
import { environment } from '@env/environment';

@Injectable({ 
  providedIn: 'root' 
})
export class ProfileService {

  constructor(
    protected readonly gql: GqlParser,
    protected readonly http: HttpClient
  ) { }

  public query(): Observable<{ authMsMyProfile: UserLogin }>{
    return this.gql.query({
      variables: {},
      cacheStrategy: 'no-cache',
      operationName: 'QueryProfile',
      query: `
        query QueryProfile {
          authMsMyProfile {
            guid
            name
            gender
            birthday
            appLoginPrincipal {
              principalId
              principalType
            }
            appLoginExt {
              paramCode
              file {
                publicUrl
              }
            }
          }
        }
      `
    }).pipe(
      map(({ data: { authMsMyProfile }}: any) => {
        const data: any = { ...authMsMyProfile };
        
        data.appLoginPrincipal?.forEach(({ principalType, principalId }: any) => {
          if (principalType === 'EMAIL_USERNAME') data.email = principalId;
          else if (principalType === 'MOBILE_USERNAME') {
            data.mobileNumber = principalId;
          }
        });
        return { authMsMyProfile: data };
      })
    );
  }

  public update(input?: UpdateProfileRq): Observable<MutationResult<{ authMsUpdateUserProfile: AppLoginSubject }>> {
    return this.gql.mutate({
      operationName: 'UpdateProfile',
      variables: { 
        input 
      },
      mutation: `
        mutation UpdateProfile($input: UpdateProfileRq) {
          authMsUpdateUserProfile(input: $input) {
            guid
          }
        }
      `,
    });
  }

  public uploadFile(formData: FormData): Observable<any>{
    return this.http.post(`${ environment.restUrl }user-profile/upload`, formData);
  }
}
